module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-35.46258ecb.jpg";